import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import usePageContent from '../../hooks/usePageContent';

const PromoListHome = () => {
    const phone = "+6587333600";
    const { lang } = useParams();
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: "home", field: 'Discount', language: "en-US" });
        }

        if (status === 'done') {
            setDataPromo(data === "" ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status])

    return (
        <section className="discount py-80">
            <div className="container container-md">
                <div className="row gy-4">
                    {
                        dataPromo.length > 0 ? (
                            dataPromo.map((item, index) => (
                                <div className="col-xl-6" key={index}>
                                    <div className="discount-item position-relative rounded-16 bg-main-one-600 overflow-hidden p-28 z-1 h-100 text-center d-flex flex-column align-items-center justify-content-center">
                                        <img
                                            src={"assets/images/shape/offer-shape.png"}
                                            alt=""
                                            className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                                        />
                                        <div className="w-100 flex-between gap-20">
                                            <img
                                                src={item.image !== "" ? item.image : "assets/images/thumbs/discount-img1.png"}
                                                alt=""
                                                className="d-sm-block d-none"
                                            />
                                            <div className="discount-item__content">
                                                <span className="fw-semibold text-white mb-20">
                                                    {item.title !== "" ? item.title : "UP TO 30% OFF"}
                                                </span>
                                                <h6 className="mb-20 text-white">
                                                    {item.description !== "" ? item.description : "57\" Odyssey Neo G9 Dual 4K UHD Quantum Mini-LED"}
                                                </h6>
                                                <Link
                                                    // to="/products"
                                                    // to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent("Voucher Promo")}`}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#voucherModal"
                                                    className="btn btn-main-one-alt rounded-pill gap-8"
                                                    tabIndex={0}
                                                >
                                                    Claim Now
                                                </Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <>
                                <div className="col-xl-6">
                                    <div className="discount-item position-relative rounded-16 bg-main-one-600 overflow-hidden p-28 z-1 h-100 text-center d-flex flex-column align-items-center justify-content-center">
                                        <img
                                            src="assets/images/shape/offer-shape.png"
                                            alt=""
                                            className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                                        />
                                        <div className="w-100 flex-between gap-20">
                                            <img
                                                src="assets/images/thumbs/discount-img1.png"
                                                alt=""
                                                className="d-sm-block d-none"
                                            />
                                            <div className="discount-item__content">
                                                <span className="fw-semibold text-white mb-20">
                                                    UP TO 30% OFF
                                                </span>
                                                <h6 className="mb-20 text-white">
                                                    57" Odyssey Neo G9 Dual 4K UHD Quantum Mini-LED
                                                </h6>
                                                <Link
                                                    // to="/products"
                                                    // to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent("Voucher Promo")}`}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#voucherModal"
                                                    className="btn btn-main-one-alt rounded-pill gap-8"
                                                    tabIndex={0}
                                                >
                                                    Claim Now
                                                </Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="discount-item position-relative rounded-16 bg-main-one-600 overflow-hidden p-28 z-1 h-100 text-center d-flex flex-column align-items-center justify-content-center">
                                        <img
                                            src="assets/images/shape/offer-shape.png"
                                            alt=""
                                            className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                                        />
                                        <div className="w-100 flex-between gap-20">
                                            <img
                                                src="assets/images/thumbs/discount-img1.png"
                                                alt=""
                                                className="d-sm-block d-none"
                                            />
                                            <div className="discount-item__content">
                                                <span className="fw-semibold  text-white mb-20">
                                                    UP TO 30% OFF
                                                </span>
                                                <h6 className="mb-20 text-white">
                                                    57" Odyssey Neo G9 Dual 4K UHD Quantum Mini-LED
                                                </h6>
                                                <Link
                                                    // to="/products"
                                                    // to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent("Voucher Promo")}`}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#voucherModal"
                                                    className="btn btn-main-one-alt rounded-pill gap-8"
                                                    tabIndex={0}
                                                >
                                                    Shop Now
                                                </Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                        )

                    }

                </div>
            </div>

            {/* Modal Klem */}
            <div
                className="modal fade"
                id="voucherModal"
                tabIndex={-1}
                aria-labelledby="voucherModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0 shadow">
                        <div className="modal-header bg-main-one-900 text-white">
                            <h5 className="modal-title text-white" id="waModalLabel">
                                Voucher
                            </h5>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body text-center">
                            <div className="list-group">
                                <div style={{
                                        fontSize:"15px",
                                        fontWeight:"500",
                                        color:"#121535",
                                        marginBottom:"15px"
                                    }}>
                                    please chat with admin now
                                </div>
                                <Link
                                    
                                    to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent("Voucher Promo")}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="list-group-item list-group-item-action"
                                    
                                >
                                    Chat with admin
                                </Link>
                                {/* {messageLinks.map((item, i) => (
                                    <Link
                                        key={i}
                                        to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(item.msg)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="list-group-item list-group-item-action"
                                    >
                                        {item.text}
                                    </Link>
                                ))} */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default PromoListHome